import React, {  useCallback, useEffect, useRef } from 'react';
import cx from 'classnames';
import styles from 'partials/dropdown/dropdown.module.scss';

export const Dropdown = React.memo(({ isOpen, children, onClickOut }) => {
	const dropdownRef = useRef();
	const listClass = cx(styles.list, {
		[styles.listOpen]: isOpen,
		[styles.listClose]: !isOpen
	});

	const handleClickOutside = useCallback(
		(e) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(e.target)
			) {
				e.stopPropagation();
				onClickOut?.();
				// setOpenDropdown(false);
			}
		},
		[onClickOut]
	);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);
		document.addEventListener('touchstart', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
			document.removeEventListener('touchstart', handleClickOutside);
		};
	}, [handleClickOutside]);

	return (
		<div className={listClass} ref={dropdownRef}>
			{children}
		</div>
	);
});